import { render, staticRenderFns } from "./PauseProject.vue?vue&type=template&id=12c83942"
import script from "./PauseProject.vue?vue&type=script&lang=js"
export * from "./PauseProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports